import { render, staticRenderFns } from "./OF.vue?vue&type=template&id=f823318c&"
import script from "./OF.vue?vue&type=script&lang=js&"
export * from "./OF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f823318c')) {
      api.createRecord('f823318c', component.options)
    } else {
      api.reload('f823318c', component.options)
    }
    module.hot.accept("./OF.vue?vue&type=template&id=f823318c&", function () {
      api.rerender('f823318c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/72235100-2/OF.vue"
export default component.exports